import flatpickr from "flatpickr";
export default class DateInput{
    
    constructor(element) {
        this._wrapper = element;
        this._input = this._wrapper.querySelector('input')
        
        this.init();
    }
    
    init(){
        this.picker = flatpickr(this._input, {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            time_24hr: true
        });
    }
    
}